export const name = 'gzBkImg';

/**
 * @ngdoc directive
 * @name gazelle.components.printosImages.bkImg.directive:gzBkImg
 *
 * @param {string=} gzBkImg path to a background image in common printos-images
 *
 * @description
 * `gz-bk-img` is an attribute directive for specifying a background image in CSS
 * with an absolute URL to a common PrintOS images location.
 *
 * @usage
 * ```html
 * <div gz-bk-img='logos/hp.png'></div>
 * ```
 * Produces
 * ```html
 * <div gz-bk-img='logos/hp.png' style="background-image: url("https://www.printos.com/images/logos/hp.png");"></div>
 * ```
 */
export default function gzBkImg(rnRegistry) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var directive = {
    restrict: 'A',
    link: gzBkImgLink,
  };

  return directive;

  //////////////////////

  function gzBkImgLink(scope, element, attrs) {
    attrs.$observe(name, function(imgPath) {
      rnRegistry.getImageUrl(imgPath)
        .then(imgUrl => {
          element.css({
            'background-image': `url("${imgUrl}")`
          });
        });
    });
  }
}
